import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../../registration.service';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';
import { SainikSchemeApplicationModel,SainikSchemeApplicationStatusHistoryModel } from './../../shared/user.model';
import swal from "sweetalert2";

@Component({
  selector: 'app-application-history',
  templateUrl: './application-history.component.html',
  styleUrls: ['./application-history.component.css']
})
export class ApplicationHistoryComponent implements OnInit {
  formSubmitted: boolean;
  RoleName: string;
  sainikSchemeApplicationModel: any={};
  sainikSchemeApplicationStatusHistoryModel : any={};
  sainikSchemeApplicationStatusHistoryModels: any={};
  mode: string;
  applicationId:any;
  title:string;
  offices:any ={};
  users:any={};
  statuss:any={};
  fileToUpload: File;
  FromUser: any;
  sainikWorkflowId: string;
  AppFromuserId: string;

  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) 
  {
    
  }

  ngOnInit() {
    this.RoleName=localStorage.getItem('userRole');
    // this.route.params.subscribe(params => {      
    //   this.mode = params['mode'];
    //   this.applicationId = params['applicationId'];      
    // });

    //From URL
    this.mode=localStorage.getItem('mode');
    this.applicationId= localStorage.getItem('applicationId');
    this.AppFromuserId = localStorage.getItem('FromuserId');
    localStorage.removeItem('applicationId'); 
    localStorage.removeItem('mode');
    localStorage.removeItem('sainikWorkflowId');


    if (this.mode=='view')
    {
      this.title = "View Application Status";
    }
    else if (this.mode=='edit')
    {
      this.title = "Edit Application Status";
      this.GetOfficesApplicationBelongsTo();
      this.GetSainikApplicationStatus();
    }
    else
    {
      this.title = "Application Status";
    }
    this.GetApplicationDetails(this.applicationId);
    this.GetApplicationStatusHistoryDetails(this.applicationId);
  }
  GetSainikApplicationStatus()
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getSainikApplicationStatus()
      .subscribe(
        (data) => {
          this.statuss = data;
          //swal("warning",this.sainikSchemeApplicationModel.ID);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
      });
  }
  GetOfficesApplicationBelongsTo()
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getOfficesApplicationBelongsTo()
      .subscribe(
        (data) => {
          this.offices = data;
          //swal("warning",this.sainikSchemeApplicationModel.ID);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
      });
  }
  GetApplicationDetails(applicationId)
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getSchemeApplicationDetailsById(this.applicationId)
      .subscribe(
        (data) => {
          this.sainikSchemeApplicationModel = data;
          //swal("warning",this.sainikSchemeApplicationModel.ID);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
      });
  }
  GetApplicationStatusHistoryDetails(applicationId)
  {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getSchemeApplicationHistoryById(this.applicationId)
      .subscribe(
        (data) => {
          this.sainikSchemeApplicationStatusHistoryModels = data[0];
          this.FromUser=this.sainikSchemeApplicationStatusHistoryModels.FromUser;
          this.sainikSchemeApplicationStatusHistoryModels.AppFromuserId=this.AppFromuserId;
          console.log(this.AppFromuserId);
          //swal("warning",this.sainikSchemeApplicationModel.ID);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
      });
  }
  onOfficeChange(officeId) {    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllUsersForOffice(officeId)
    .subscribe(
    (data) => {
      this.users=data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error) => {
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });
  } 
  update(form: NgForm)
  {

  }
  onSubmit(form: NgForm) {
    if (!form.invalid) 
    {              
      document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationStatusHistoryModel.ApplicationId = this.applicationId;

      this.sainikSchemeApplicationStatusHistoryModel.AssignedFromUserName=this.FromUser;
      this.sainikSchemeApplicationStatusHistoryModel.AppFromuserId=this.AppFromuserId;
      this.userService.updateAppliationStatus(this.sainikSchemeApplicationStatusHistoryModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Status Updated Successfully!','success');
        this.router.navigate(['/home/SchemesApprovals']);          
        }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    }
    else
    {
      this.formSubmitted = true;
    }
  }



  //Upload Status
  UploadStatusFileInput(file: FileList) {
    
      //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 5048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.userService.uploadImage(data);
        x.subscribe(
          (response) => {
            // console.log(response);
            // this.app.APP_PA_PhotoErrorMessage="";
    
          }, (error) => {
            let i: any = document.getElementById('UploadStatus');
            i.value = "";
            if (error.status == 400) {
              // this.FeasibilityPDFUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('UploadStatus');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }
    
    
    getMarksheetPDFUrl() {
      let imagename = null;
      try {
        imagename = document.getElementById('UploadStatus');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/schemes/application-history/application-history.component.ts